<template>
  <div class="common-confirm">
    <b-modal ref="confirm" centered no-stacking :title="title" @ok="onOk" @hidden="onHidden">
      <p v-for="line in message">{{ line }}</p>
    </b-modal>
  </div>
</template>

<script>
import eventHub from '@/utils/eventHub';

export default {
  name: 'CommonConfirm',
  data() {
    return {
      title: '',
      message: [],
      callback: null,
    };
  },
  methods: {
    onOk(evt) {
      if (this.callback !== null) {
        this.callback(evt);
      }
    },
    onHidden(evt) {
      this.title = '';
      this.message = [];
      this.callback = null;
    },
  },
  mounted() {
    eventHub.$on('confirm', (title, message, callback) => {
      this.title = title;
      this.message = message.split(/\n/);
      this.callback = callback;
      this.$refs['confirm'].show();
    });
  },
};
</script>

<style scoped>
</style>

<style>
#b-toaster-top-left {
  margin-top: 56px;
}
</style>
